module.exports = __webpack_public_path__ + "static/media/plus.39cf8c8f.svg";